import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { IPStatusDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-ipstatus-container',
  templateUrl: './ipstatus-container.component.html',
  styleUrls: ['./ipstatus-container.component.scss']
})
export class IPStatusContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  ipstatuss$: Observable<IPStatusDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("IPStatus");
    this.ipstatuss$ = this.gatwayFacade.loadGateway("IPStatus");
    this.ipstatuss$.subscribe(data => {
      console.log("data: cont.",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteIPStatus(deletedValue: any) {
    this.gatwayFacade.remove("IPStatus", deletedValue);
    // this.store.dispatch(IPStatusStoreActions.removeIPStatus({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitIPStatus(formValue: any) {
    console.log("form value: ", formValue);
    formValue.IPStatuss = formValue.IPStatuss.reverse();
    event.preventDefault();
    const pullData = formValue.IPStatuss;
    //const newPullData = formValue.IPStatuses;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllIPStatus = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllIPStatus.push(pullData[i]);
    }
  }

// check if the addAllIPStatus array is not empty, then dispatch the data to the store
   if(addAllIPStatus.length !== 0) {
    this.gatwayFacade.add('IPStatus', addAllIPStatus);
    // this.store.dispatch(IPStatusStoreActions.addIPStatus({newIPStatus: addAllIPStatus}));

   }

// dispatch update data to the store
this.gatwayFacade.update('IPStatus', allUpdates, ['id']);
    // this.store.dispatch(IPStatusStoreActions.updateIPStatus({updateIPStatus: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }

}



